// 设备状态枚举 - 支持三种状态：online、offline、in_use
export enum DeviceStatus {
  ONLINE = 'online',     // 设备与服务器保持TCP连接，未被任何用户使用
  OFFLINE = 'offline',   // 设备与服务器的TCP连接中断
  IN_USE = 'in_use'      // 设备与服务器保持TCP连接，且被某一用户占用
}

// 设备信息接口
export interface DeviceInfo {
  id: string;
  ipAddress: string;
  tcpPort: number;
  udpPort: number;
  name?: string;
}

// 设备统计信息接口
export interface DeviceStatistics {
  packetsReceived: number;
  packetsSent: number;
  bytesReceived: number;
  bytesSent: number;
}

// 设备事件类型（使用泛型避免循环引用）
export interface DeviceEvents {
  statusChanged: { device: any; online: boolean };
  audioStarted: any;
  audioStopped: any;
  audioDataReceived: { device: any; data: any };
  pttStarted: any;
  pttStopped: any;
}

// 设备接口
export interface IDevice {
  getInfo(): DeviceInfo;
  getId(): string; // 获取字符串类型的ID
  getDeviceId(): number; // 获取数字类型的ID（用于API调用）
  getStatus(): DeviceStatus;
  isOnline(): boolean;
  connect(): Promise<void>;
  disconnect(): Promise<void>;
  on<K extends keyof DeviceEvents>(event: K, callback: (data: DeviceEvents[K]) => void): void;
  off<K extends keyof DeviceEvents>(event: K, callback: (data: DeviceEvents[K]) => void): void;
}

// 连接接口
export interface Connection {
  connect(): Promise<void>;
  disconnect(): Promise<void>;
  isConnected(): boolean;
  on(event: string, callback: Function): void;
  off(event: string, callback: Function): void;
}
